export default __webpack_public_path__ + "static/media/font.a0cf43c1.woff2";